import { IconProps } from '@/icons/common';

export const FloatingArea = (props: IconProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="98"
    height="25"
    viewBox="0 0 98 25"
    fill="none"
  >
    <g opacity="0.65">
      <g filter="url(#filter0_f_354_3489)">
        <ellipse cx="49.0793" cy="12.5562" rx="42.9192" ry="5.6033" fill="#F67C38" />
      </g>
      <g filter="url(#filter1_f_354_3489)">
        <ellipse cx="57.3362" cy="12.1044" rx="24.761" ry="3.73554" fill="#EA5400" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_354_3489"
        x="0.160156"
        y="0.952881"
        width="97.8379"
        height="23.2065"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_354_3489" />
      </filter>
      <filter
        id="filter1_f_354_3489"
        x="28.0752"
        y="3.8689"
        width="58.5225"
        height="16.4712"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="2.25" result="effect1_foregroundBlur_354_3489" />
      </filter>
    </defs>
  </svg>
);

export const Deco = (props: IconProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <rect
      x="1"
      y="1"
      width="5.83811"
      height="5.83811"
      stroke="#F67C38"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <rect
      x="7"
      y="7"
      width="5.83811"
      height="5.83811"
      stroke="#F67C38"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <rect
      x="1"
      y="13"
      width="5.83811"
      height="5.83811"
      stroke="#F67C38"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <rect
      x="13"
      y="1"
      width="5.83811"
      height="5.83811"
      stroke="#F67C38"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <line
      x1="18.1074"
      y1="1"
      x2="25.9455"
      y2="1"
      stroke="#F67C38"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <line
      y1="-1"
      x2="7.83811"
      y2="-1"
      transform="matrix(0 -1 -1 0 0 25.8379)"
      stroke="#F67C38"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
